import { render, staticRenderFns } from "./HowXt.vue?vue&type=template&id=704b41d2&scoped=true"
import script from "./HowXt.vue?vue&type=script&lang=ts"
export * from "./HowXt.vue?vue&type=script&lang=ts"
import style0 from "./HowXt.vue?vue&type=style&index=0&id=704b41d2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704b41d2",
  null
  
)

export default component.exports